import { formatCurrency } from "./currency";

type Formatter = (value: number) => string;

export const formatBalance = (value: number, formatter: Formatter = formatCurrency): string => {
  if (value > 0) {
    return `+ ${formatter(value)}`;
  }
  if (value < 0) {
    return `- ${formatter(Math.abs(value))}`;
  }

  return formatter(0);
};

export const getBalanceColor = (value: number, reverseNegativeColors = false): string => {
  if (reverseNegativeColors) {
    return value <= 0 ? "var(--green)" : "var(--red-600)";
  }
  return value >= 0 ? "var(--green)" : "var(--red-600)";
};
